import { Input } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';

@Component({
  selector: 'app-charges',
  templateUrl: './charges.component.html',
  styleUrls: ['./charges.component.css'],
})
export class ChargesComponent implements OnInit {
  hasChargesConfig: boolean = false;
  selectedTabIndex: any = 0;
  constructor(private configService: ConfigService) {}

  ngOnInit(): void {
    this.loadChargeConfig();
  }

  _additionalCharges: any = [];
  @Input()
  set additionalCharges(data: any) {
    this._additionalCharges = data;
  }
  get additionalCharges() {
    return this._additionalCharges;
  }

  _invoiceefrence: any = [];
  @Input()
  set invoiceReference(data: any) {
    this._invoiceefrence = data;
  }
  get invoiceReference() {
    return this._invoiceefrence;
  }

  _mawb: string;
  @Input()
  set mawb(id: string) {
    this._mawb = id;
  }
  get mawb() {
    return this._mawb;
  }

  _isClosed: boolean = true;
  @Input()
  set isClosed(b: boolean) {
    this._isClosed = b;
  }
  get isClosed() {
    return this._isClosed;
  }

  loadChargeConfig() {
    this.configService.fetchConfig('additional_charges').then(res => {
      if (res.data) {
        this.hasChargesConfig = (res.data || []).length > 0;
      }
    });
  }
}
